export default __webpack_public_path__ + "static/media/heart_full.4eb7646d.svg";